
import { defineComponent, ref } from '@nuxtjs/composition-api'
import { ItemHistory } from '~/assets/ts/items/history'
import ElementSnapSlider from '~/components/element/elementSnapSlider.vue'
import ElementHeadline from '~/components/element/elementHeadline.vue'

export default defineComponent({
  components: {
    ElementHeadline,
    ElementSnapSlider,
  },
  setup() {
    const historyList = ref([] as { [key: string]: string }[])

    new ItemHistory().getList().then((result: any) => {
      historyList.value = result
    })

    /*
      Images Host
    */

    const imagesHost: string = process.env.imagesHost as string

    return { historyList, imagesHost }
  },
})
